import { render, staticRenderFns } from "./AmeliaRevWriting.vue?vue&type=template&id=39f5a55b"
import script from "./AmeliaRevWriting.vue?vue&type=script&lang=js"
export * from "./AmeliaRevWriting.vue?vue&type=script&lang=js"
import style0 from "./AmeliaRevWriting.vue?vue&type=style&index=0&id=39f5a55b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports